import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.css';

export interface ThemeToggleProps {
  className?: string;
  showLabel?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  className = '', 
  showLabel = true 
}) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`theme-toggle-container ${className}`}>
      {showLabel && (
        <label 
          htmlFor="theme-toggle" 
          className="theme-toggle-label"
        >
          Theme:
        </label>
      )}
      <button
        id="theme-toggle"
        className="theme-toggle-button"
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
        aria-pressed={theme === 'dark'}
        type="button"
      >
        <span className="theme-toggle-icon" aria-hidden="true">
          {theme === 'light' ? '🌙' : '☀️'}
        </span>
        <span className="theme-toggle-text">
          {theme === 'light' ? 'Dark' : 'Light'}
        </span>
      </button>
    </div>
  );
};